import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['account', 'make', 'model', 'style', 'color'];
  static values = { url: String };

  connect() {
    if (this.hasAccountTarget && this.accountTarget.value && this.makeTarget.options.length <= 1) {
      this.loadMakes();
    }
  }

  loadMakes() {
    this.clear(this.modelTarget, this.styleTarget, this.colorTarget);
    this.populate(this.makeTarget, { level: 'makes', account_id: this.accountTarget.value });
  }

  loadModels() {
    this.clear(this.styleTarget, this.colorTarget);
    this.populate(this.modelTarget, { level: 'models', car_make_id: this.makeTarget.value });
  }

  loadStyles() {
    this.clear(this.colorTarget);
    this.populate(this.styleTarget, { level: 'styles', car_model_id: this.modelTarget.value });
  }

  loadColors() {
    this.populate(this.colorTarget, { level: 'colors', car_style_id: this.styleTarget.value });
  }

  async populate(select, params) {
    this.clear(select);

    const parentId = Object.values(params)[1];
    if (!parentId) return;

    const query = new URLSearchParams(params);
    const response = await fetch(`${this.urlValue}?${query}`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;

    const items = await response.json();
    items.forEach(item => {
      const option = new Option(item.name, item.id);
      select.add(option);
    });
    select.disabled = items.length === 0;
  }

  clear(...selects) {
    selects.forEach(select => {
      select.innerHTML = '<option value="">Please select</option>';
      select.disabled = true;
    });
  }
}
